import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { configurationActions } from "../_actions";
import { ServiceUtil } from "../_services";

function MaintenanceChecker({
  history,
  isLPXInMaintenanceCheck,
  isLPXInMaintenance,
}) {
  useEffect(() => {
    checkMaintenance();
    const unlisten = history.listen((location) => {
        checkMaintenance();
    });
    return () => {
      unlisten();
    };
  }, []);
  const checkMaintenance = async () => {
    isLPXInMaintenanceCheck();
  };

  return null;
}
function mapStateToProps(state) {
  const { isLPXInMaintenance } = state.configuration;
  return {
    isLPXInMaintenance,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    isLPXInMaintenanceCheck: () => {
      dispatch(configurationActions.isLPXInMaintenance());
    },
  };
};
const connectedMaintenanceChecker = connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenanceChecker);
export default withRouter(connectedMaintenanceChecker);



// WEBPACK FOOTER //
// ./src/utils/maintenanceChecker.jsx